require('./personeticsTeaser.scss');

// @vendors
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @images
const emptyStateImg = require('assets/images/payroll_account_open.svg');
const openTutorialImg = require('assets/images/icon-tutorial.svg');

//@components
const PersoneticsTeaserBanner = require('../personeticsTeaserBanner/personeticsTeaserBanner');
const PersoneticsPGBox = require("../personeticsPGBox/personeticsPGBox");
const PersoneticsSubscriptionModal = require('../personeticsSubscriptionModal/personeticsSubscriptionModal');
const PersoneticsSubscriptionErrorModal = require('../personeticsSubscribtionErrorModal/personeticsSubscribtionErrorModal');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @actions
const { initPersonetics, setInsightCloseStatus, validateVirtualOfficeForPersonetics } = require('actions/personeticsTeaser');
const personeticsActions = require('actions/personeticsInboxInsights');
const personeticsDetailsActions = require('actions/personeticsInsightDetails');
const personeticsSubscriptionActions = require('actions/personeticsSubscription');
const { Fragment } = require('react');

//@utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { toCamelCase, getLastNChars } = require('utilities/stringHelper');
const {
    recordLinkV2,
} = require("utilities/tagging");

// @constants
const { PERSONETICS } = require('constants/flagBasedFeatures');
const {
    PERSONETICS_EVENT_CATEGORY,POSITION_GLOBAL_EVENT_CATEGORY
} = require('constants/tagging');

class PersoneticsTeasersView extends React.Component {
    constructor(props) {
        super(props);

        this.buildTeaserInsights = this.buildTeaserInsights.bind(this);
        this.checkboxClick = this.checkboxClick.bind(this);
        this.handleAccessFinanceClick = this.handleAccessFinanceClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleInsightCloseClick = this.handleInsightCloseClick.bind(this);
        this.handleRetryClick = this.handleRetryClick.bind(this);
        this.handleTeaserClick = this.handleTeaserClick.bind(this);
        this.updatePersoneticsSubscriptionStatus = this.updatePersoneticsSubscriptionStatus.bind(this);
        this.getTealiumAnalytics = this.getTealiumAnalytics.bind(this)
    }
componentDidMount(){
    const { immPersoneticsInsights } = this.props;
    const immInsights = immPersoneticsInsights.get('insights');
    const isAllInsightsClosed = immPersoneticsInsights.get('isAllInsightsClosed');
    const immInsightsToShow = immInsights.filter((immInsight) => {
        return !immInsight.get('closeStatus');
    });
    const allProductDetails = this.getAllProductDetails();
    if (!!immInsightsToShow.size && !isAllInsightsClosed) {
        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: "visualizacion full",
            zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY,
            ...allProductDetails
        }
        recordLinkV2(analyticsData);
    }
    else
    {
        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: "visualizacion empty",
            zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY,
            ...allProductDetails
        }
        recordLinkV2(analyticsData);
    }

}
getAllProductDetails() {
    const allProductDetails = [];
    const productTitle = [];
    const productInsightStatus = [];
    const productIndex = [];
    const personeicsInbox = [];
    const { immPersoneticsInsights } = this.props;
    const insights =  immPersoneticsInsights.get('insights');
    insights.map((insight, key) => {
        const insightStatus = insight.get('status');
        const title = insight.get('teaserBlocks').find((teaser) => {
            return teaser.get('blockId') === 'title';
        });
        productTitle.push(title.get('text'));
        productInsightStatus.push(insightStatus);
        productIndex.push(key + 1);
        personeicsInbox.push(['personetics-pg']);
    });
    allProductDetails.push({
        tealium_event: 'product_impression',
        product_impression_id: productTitle,
        product_impression_name: productTitle,
        product_impression_list: personeicsInbox,
        product_impression_category: productInsightStatus,
        product_impression_position: productIndex,
    });
    return allProductDetails[0];
}
getCurrentProduct(id) {
    const { immPersoneticsInsights } = this.props;

    const insights = immPersoneticsInsights.get('insights');
    const currentProductDetails = [];
    insights.map((insight, key) => {
        const insightStatus = insight.get('status');
        const teaserid = insight.get('id');

        const title = insight.get('teaserBlocks').find((teaser) => {
            return teaser.get('blockId') === 'title';
        });

        currentProductDetails.push({
            teaser_id: teaserid,
            tealium_event: 'product_click',
            product_name: title.get('text'),
            product_id: title.get('text'),
            product_category: insightStatus,
            product_position: key + 1,
        });
    });

    return currentProductDetails.filter((currentProduct) => {
        return currentProduct.teaser_id === id;
    });
}
    handleTeaserClick(id){
        const { history, setClickedTeaser, getPersoneticsInsightDetails } = this.props;
        setClickedTeaser(id);
        getPersoneticsInsightDetails(id);
        const currentProductDetails = this.getCurrentProduct(id)[0];
        delete currentProductDetails.teaser_id;
        const analyticsData = {
            categoriaEvento:PERSONETICS_EVENT_CATEGORY,
            accionEvento: "card open",
            etiquetaEvento: currentProductDetails.product_name,
            zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY,
            ...currentProductDetails
        }
        recordLinkV2(analyticsData);
        history.push(`/myprofile/my-finances`);
    }

    handleInsightCloseClick(id) {
        const currentProductDetails = this.getCurrentProduct(id)[0];
        delete currentProductDetails.teaser_id;
        const analyticsData = {
            categoriaEvento:PERSONETICS_EVENT_CATEGORY,
            accionEvento: "card close",
            etiquetaEvento: currentProductDetails.product_name,
            zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY,
            ...currentProductDetails

        }
            recordLinkV2(analyticsData);
        this.props.setInsightCloseStatus(id)
    }
    getTealiumAnalytics() {
        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: "mas noticias sobre tus finanzas",
            zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY
    }
        recordLinkV2(analyticsData);
    }

    buildTeaserInsights(immInsights) {
        const { immProfile } = this.props;
        const userAlias = immProfile.get('alias').trim() || toCamelCase(immProfile.get('nombreCliente').trim());
        const insights = immInsights.map((immInsight, index) => {
            return (
                <PersoneticsTeaserBanner
                    key={index}
                    immInsight={immInsight}
                    onClose={this.handleInsightCloseClick}
                    onTeaserClick={this.handleTeaserClick}
                />
            );
        });
        const tutorialTooltipTarget = (
            <img
                src={openTutorialImg}
                className="personetics-teaser__tooltip-element"
            />
        );

        return (
            <React.Fragment>
                <div className="personetics-teaser__header">
                    <FormattedText value="personetics-personetics_teaserTitle" injectedStrings={[userAlias]}/>
                    <OKTooltip
                        content="personetics-personetics_teaserTooltip"
                        offset={[0, -15]}
                        target={tutorialTooltipTarget}
                    />
                </div>
                <div className="personetics-teaser__content">
                    {insights}
                </div>
                <div className="personetics-teaser__footer-section">
                    <OKLink
                        extraClass="personetics-teaser__footer-link"
                        modifier="widget"
                        to="/myprofile/my-finances"
                        onClick={this.getTealiumAnalytics}
                    >
                        <FormattedText value="personetics-personetics_teaserLinkText" injectedStrings={[userAlias]}/>
                    </OKLink>
                </div>
            </React.Fragment>
        );
    }

    buildEmptyState() {
        const buttonText = formatText('personeticsEmptyState-buttonText');

        return (
            <div className="personetics-teaser__empty-state">
                <div className='personetics-teaser__empty-state-image-wrapper'>
                    <img
                        src={emptyStateImg}
                        className="personetics-teaser__empty-state-image"
                    />
                </div>
                <div className='personetics-teaser__empty-state-content-wrapper'>
                    <div className="personetics-teaser__empty-state-title">
                        <FormattedText value="personeticsEmptyState-title"/>
                    </div>
                    <div className="personetics-teaser__empty-state-button">
                        <OKButton
                            modifier="ghost-inverse"
                            onClick={() => {
                                this.props.history.push('/myprofile/my-finances');
                            }}
                        >
                            {buttonText}
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    buildPersneticsTeasersView() {
        const { immPersoneticsInsights } = this.props;

        const immInsights = immPersoneticsInsights.get('insights');
        const isAllInsightsClosed = immPersoneticsInsights.get('isAllInsightsClosed');
        let content;
        const immInsightsToShow = immInsights.filter((immInsight) => {
            return !immInsight.get('closeStatus');
        });

        if (!!immInsightsToShow.size && !isAllInsightsClosed) {
            content = this.buildTeaserInsights(immInsightsToShow);
        } else {
            content = this.buildEmptyState();
        }

        return (
            <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation-bottom">
                <div className="personetics-teaser">
                    {content}
                </div>
            </div>
        );
    }

    handleCloseModal() {
        this.props.closePersoneticsModal();
    }

    handleAccessFinanceClick() {
        const analyticsData = {
            categoriaEvento:PERSONETICS_EVENT_CATEGORY,
            accionEvento: "acceder a mis finanzas",
            zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY
        }
        recordLinkV2(analyticsData);
        this.props.openPersoneticsSubscriptionModal();
    }

    handleRetryClick() {
        const {
            getPersoneticsSubscriptionStatus,
            immPersoneticsSubscriptionDetails,
            immPersoneticsTeaser,
            immPersoneticsVirtualOffices,
            initPersonetics,
            validateVirtualOfficeForPersonetics,
            immAccounts,
            immCards,
        } = this.props;
        const analyticsData = {
            categoriaEvento:PERSONETICS_EVENT_CATEGORY,
            accionEvento: "reintentar",
            zonaInicio: POSITION_GLOBAL_EVENT_CATEGORY
        }
        recordLinkV2(analyticsData);
        const initSuccess = immPersoneticsTeaser.get("initSuccess");
        const hasErrorContent = immPersoneticsTeaser.get("initErrorDesc");
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');
        const immAccountById = immAccounts && immAccounts.get('byId');
        const immAccountByOrder = immAccounts && immAccounts.get('byOrder');
        const accounts = immAccountByOrder && immAccountByOrder.map((accountId) => {
        const immAccount = immAccountById && immAccountById.get(accountId);
        return {
            contractNumber: immAccount.get('newContractNumber'),
            productType: immAccount.get('newProduct'),
            productSubtype: immAccount.get('accountType'),
            standard: immAccount.get('standard'),
            availableBalance: immAccount.getIn(['balances', 'availableBalance','amount']),
            currentBalance: immAccount.getIn(['balances', 'realBalance','amount'])
        };
        });
        const cards = immCardByOrder && immCardByOrder.map((cardId) => {
        const immCard = immCardById && immCardById.get(cardId);
        return {
            contractNumber: immCard.getIn(['contract', 'number']),
            cardId: immCard.getIn(['contract', 'product']) +
                    immCard.getIn(['contract', 'number']) +
                    getLastNChars(immCard.get('number'), 4, ''),
            productType: immCard.get('newProduct'),
            productSubtype: immCard.get('productSubType'),
            standard:  immCard.getIn(['product','standard']),
            status: immCard.get('statusCode'),
            descStatus: immCard.get('status'),
            availableBalance: immCard.getIn(['availableBalance','amount']),
            disposedBalance: immCard.getIn(['balanceDrawn','amount']),
            limit: immCard.getIn(['limit','amount'])
        };
        })
        immPersoneticsSubscriptionDetails.get('fetchError') && getPersoneticsSubscriptionStatus();
        const isPersoneticsAlreadySubscribed = immPersoneticsSubscriptionDetails.get('isSubscribed');

        isPersoneticsAlreadySubscribed && immPersoneticsVirtualOffices.get('virtualOfficeRequestError') && validateVirtualOfficeForPersonetics(accounts,cards);
        isPersoneticsAlreadySubscribed && !initSuccess && hasErrorContent && initPersonetics();
    }

    updatePersoneticsSubscriptionStatus() {
        const acceptedString = formatText('personeticsSubscriptionModal-acceptedStringText');
        this.props.postPersoneticsSubscriptionStatus(acceptedString);
    }
    checkboxClick(value) {
        this.props.termsAndConditionscheckboxClick(value);
    }

    render() {
        const {
            immFlagBasedFeatures,
            immPersoneticsInsights,
            immPersoneticsSubscriptionDetails,
            immPersoneticsTeaser,
            immPersoneticsVirtualOffices,
            immProfile,
        } = this.props;
        const isPersoneticsAlreadySubscribed = immPersoneticsSubscriptionDetails.get('isSubscribed');
        const checkboxChecked = immPersoneticsSubscriptionDetails.get('termsAndConditionChecked');
        const teasersContent = this.buildPersneticsTeasersView();
        const userAlias = immProfile.get('alias').trim() || toCamelCase(immProfile.get('nombreCliente').trim());
        const pgBoxContent = (
            <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation-bottom">
                <PersoneticsPGBox
                    buttonText={formatText('personeticsPGBox-buttonText')}
                    description={formatText('personeticsPGBox-description')}
                    modifier="primary"
                    onButtonClick={this.handleAccessFinanceClick}
                    title={<FormattedText
                        value='personeticsPGBox-title'
                        injectedStrings={[userAlias]}
                    />}
                />
            </div>
        )
        const pgBoxErrorContent = (
            <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation-bottom">
                <PersoneticsPGBox
                    buttonText={formatText('common-retry')}
                    description={formatText('personeticsPGErrorBox-description')}
                    modifier="ghost-inverse"
                    onButtonClick={this.handleRetryClick}
                    title={formatText('personeticsPGErrorBox-title')}
                />
            </div>
        )
        let personeticsContent;
        const initSuccess = immPersoneticsTeaser.get("initSuccess");
        const hasErrorContent = immPersoneticsTeaser.get("initErrorDesc");
        const isPersoneticsFlagEnabled = immFlagBasedFeatures.get(PERSONETICS);

        if (immPersoneticsSubscriptionDetails.get('isFetching') || immPersoneticsInsights.get('isFetchingContent')) {
            personeticsContent = <LoadingSection />
        } else if ((!initSuccess && hasErrorContent) || immPersoneticsSubscriptionDetails.get('fetchError') || (immPersoneticsVirtualOffices.get('virtualOfficeRequestError') && isPersoneticsFlagEnabled)) {
            personeticsContent = pgBoxErrorContent;
        } else if (immPersoneticsSubscriptionDetails.get('fetchSuccess')) {
            personeticsContent = isPersoneticsAlreadySubscribed ? teasersContent : pgBoxContent;
        }

        let showPersoneticsSubscribeModal = false;
        const showPersoneticsSubscribeErrorModal = immPersoneticsSubscriptionDetails.get('showErrorModal');

        if (!showPersoneticsSubscribeErrorModal && (immPersoneticsSubscriptionDetails.get('termsAndConditionsFetching')
        || immPersoneticsSubscriptionDetails.get('showSubscriptionModal'))) {
            showPersoneticsSubscribeModal = true;
        }

        const subscribeModalContent = (
            <PersoneticsSubscriptionModal
                checkboxChecked={checkboxChecked}
                checkboxClick={this.checkboxClick}
                handleClose={this.handleCloseModal}
                handleSubmit={this.updatePersoneticsSubscriptionStatus}
                isUpdatingPersoneticsSubscription={immPersoneticsSubscriptionDetails.get('termsAndConditionsFetching')}
                showModal={showPersoneticsSubscribeModal}
            />
        );

        const subscribeModalErrorContent = (
            <PersoneticsSubscriptionErrorModal
                description={formatText('personeticsSubscriptionErrorModal-description')}
                handleSubmit={this.handleCloseModal}
                showModal={showPersoneticsSubscribeErrorModal}
                title={formatText('personeticsSubscriptionErrorModal-title')}
            />
        );

        return (
            <Fragment>
                {subscribeModalContent}
                {subscribeModalErrorContent}
                {personeticsContent}
            </Fragment>
        );
    }
}

PersoneticsTeasersView.propTypes = {
    closePersoneticsModal: PropTypes.func.isRequired,
    getPersoneticsSubscriptionStatus: PropTypes.func.isRequired,
    getPersoneticsInboxInsights: PropTypes.func.isRequired,
    getPersoneticsInsightDetails: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immPersoneticsInsights: PropTypes.object.isRequired,
    immPersoneticsTeaser: PropTypes.object.isRequired,
    immPersoneticsVirtualOffices: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immCards: PropTypes.object,
    immAccounts: PropTypes.object,
    immPersoneticsSubscriptionDetails: PropTypes.object.isRequired,
    initPersonetics: PropTypes.func.isRequired,
    openPersoneticsSubscriptionModal: PropTypes.func.isRequired,
    postPersoneticsSubscriptionStatus: PropTypes.func.isRequired,
    setClickedTeaser: PropTypes.func.isRequired,
    setInsightCloseStatus: PropTypes.func.isRequired,
    termsAndConditionscheckboxClick: PropTypes.func.isRequired,
    validateVirtualOfficeForPersonetics: PropTypes.func,
};

module.exports.constructor = PersoneticsTeasersView;
module.exports.PersoneticsTeasersView = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immPersoneticsInsights: state.personeticsTeaser,
        immProfile: state.profile,
        immCards: state.cards,
        immAccounts: state.accounts,
        immPersoneticsSubscriptionDetails: state.personeticsSubscription,
        immPersoneticsVirtualOffices: state.personeticsVirtualOffices,
    }),
    {
        getPersoneticsInboxInsights: personeticsActions.getPersoneticsInboxInsights,
        getPersoneticsInsightDetails: personeticsDetailsActions.getPersoneticsInsightDetails,
        postPersoneticsSubscriptionStatus: personeticsSubscriptionActions.postPersoneticsSubscriptionStatus,
        openPersoneticsSubscriptionModal: personeticsSubscriptionActions.openPersoneticsSubscriptionModal,
        closePersoneticsModal: personeticsSubscriptionActions.closePersoneticsModal,
        termsAndConditionscheckboxClick: personeticsSubscriptionActions.termsAndConditionscheckboxClick,
        setClickedTeaser: personeticsActions.setClickedTeaser,
        setInsightCloseStatus,
        validateVirtualOfficeForPersonetics,
        initPersonetics
    }
)(withRouter(PersoneticsTeasersView));
